import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {getHours, getMinutes} from 'app/core/helpers/date';

@Injectable()
export class ServerTimeService {
    constructor(private httpClient: HttpClient) {}

    fetchServerTime(): Promise<{hours: number; minutes: number}> {
        return this.httpClient
            .get('/dashboard/get_server_time')
            .toPromise()
            .then((data: {current_time: string}) => {
                let [, hours, minutes] = /(\d{2}):(\d{2})/.exec(data.current_time);
                return {
                    hours: Number(hours),
                    minutes: Number(minutes),
                };
            })
            .catch(() => {
                let current = new Date();
                return {
                    hours: getHours(current),
                    minutes: getMinutes(current),
                };
            });
    }
}
